import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CollaboratorsService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('collaborators/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('collaborators/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('collaborators/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('collaborators/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('collaborators/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('collaborators/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('collaborators/delete', val_id);
  }
}
